import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'
import { HexNumber } from '@lukso/controllerapps-sharedlogic-primitives'

const ExtraInitializationParamsSchema = z.object({
  extraInitializationParamsValue: z.instanceof(HexNumber),
})

type ExtraInitializationParamsProps = z.infer<
  typeof ExtraInitializationParamsSchema
>

export class ExtraInitializationParams extends ValueObject<ExtraInitializationParamsProps> {
  public getValue(): HexNumber {
    return this.props.extraInitializationParamsValue
  }

  public static create(
    props: ExtraInitializationParamsProps
  ): ExtraInitializationParams {
    const validatedProps = ExtraInitializationParamsSchema.parse(props)
    return new ExtraInitializationParams(validatedProps)
  }
}
